import React from 'react';
import {Link} from 'react-router-dom';
import PageNotFound from '../assets/images/not_found.png';
import '../style/NotFound.css'

class NotFoundPage extends React.Component {
    render() {
        return <div id='not-found-page'>
            <img src={PageNotFound} width={document.documentElement.clientWidth} height={document.documentElement.clientHeight} alt='not-found'/>
            <div className='l404'>404</div>
            <div className='text404 col'>
                <div className="row">   Вернитесь на <div className='link404 col'><Link to="/">главную</Link></div></div>
              <div className="row"> и попробуйте еще раз</div>

            </div>
        </div>;
    }
}

export default NotFoundPage;